import WithRender from "../../templates/layouts/layoutConfiguration.html";

export default WithRender({});
